import { render, staticRenderFns } from "./ExtraordinaryEvents.vue?vue&type=template&id=01a8aeb3&scoped=true&"
import script from "./ExtraordinaryEvents.vue?vue&type=script&lang=js&"
export * from "./ExtraordinaryEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a8aeb3",
  null
  
)

export default component.exports